var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-loading-spinner",attrs:{"data-deliver-part":"deliver-code"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"width":"8","color":_vm.styles.otColorBlue500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }